import { render, staticRenderFns } from "./ConfirmationHeader.vue?vue&type=template&id=c0d3bcf6&"
import script from "./ConfirmationHeader.vue?vue&type=script&lang=js&"
export * from "./ConfirmationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports